import React from "react";
import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { useThemeMode } from "../../components/theme";
import { colours as constColours } from "../../consts";
import { THEME_MODES } from "../../helpers/constant";

const CreateCampaignStepper = ({ current }) => {
    const { colours, FONT } = useThemeMode();

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div style={{ display: "flex", flexDirection: "row" }}>
                <Avatar
                    sx={(theme) => ({
                        background: current <= 2 ? colours.purple100 : colours.dividergray,
                        color: current <= 2 ? constColours.white : colours.black,
                        width: 24,
                        height: 24,
                        fontSize: FONT.SIZE_14,
                        marginRight: 1,
                    })}
                >
                    1
                </Avatar>
                <Typography component="span" variant="subtitle" sx={{ fontSize: { xs: FONT.SIZE_14, sm: FONT.SIZE_16 } }}>Campaign Details</Typography>
            </div>
            <Typography
                component="div"
                sx={(theme) => ({
                    marginRight: 1,
                    marginLeft: 1,
                    width: 60,
                    height: 0,
                    borderBottom: `1px solid ${theme.palette.mode === THEME_MODES.LIGHT ? colours.dividergray : colours.grayDisabled}`,
                })}
            />
            <div style={{ display: "flex", flexDirection: "row" }}>
                <Avatar
                    sx={(theme) => ({
                        background: current === 2 ? colours.purple100 : (theme.palette.mode === THEME_MODES.LIGHT ? colours.dividergray : colours.grayDisabled),
                        color: current === 2 ? constColours.white : colours.black,
                        width: 24,
                        height: 24,
                        fontSize: FONT.SIZE_14,
                        marginRight: 1,
                    })}
                >
                    2
                </Avatar>
                <Typography component="span" variant="subtitle" sx={{ fontSize: { xs: FONT.SIZE_14, sm: FONT.SIZE_16 } }}>Add Insights</Typography>
            </div>
        </div>
    )
}

export default CreateCampaignStepper;